import type { Buff } from '@ml/core';

const STAT_NAME: Record<string, string> = {
  hp: 'HP tối đa',
  handAttack: 'Tấn công thường',
  abilityAttack: 'Sức mạnh skill',
};
const COLOR_NAME: Record<string, string> = { R: 'Đỏ', B: 'Lam', G: 'Lục', Y: 'Vàng', P: 'Tím' };

/** Buff chưa có hiệu lực trong core M1 (s6 ghi "chuyển sang s10"; cần sửa resolve/spawn). */
export const INERT_BUFF_TYPES = new Set(['boosterShieldTurns', 'essenceStartCharge']);

export function buffText(b: Buff): string {
  switch (b.type) {
    case 'statPct':
      return `${STAT_NAME[b.stat ?? ''] ?? b.stat} +${b.value}%`;
    case 'colorSpawnWeight':
      return `Ngọc ${COLOR_NAME[b.color ?? ''] ?? b.color} rơi nhiều hơn (+${b.value})`;
    case 'ultGainPct':
      return `Sạc ult nhanh hơn +${b.value}%`;
    case 'boosterShieldTurns':
      return `Booster được khiên ${b.value} lượt (chưa áp ở M1)`;
    case 'essenceStartCharge':
      return `Ngọc ấn sinh ra có sẵn ${b.value} điện tích (chưa áp ở M1)`;
    default:
      return `${b.type} ${b.value}`;
  }
}
